//
// Scroll to next section
// 

// Fn to add onClick and onChange states an "error" CSS class to ":invalid" form items
var fn_form_invalid = function () {

    $(".powermail_form input.a-button-design").on("click", function(){
        $(this).parents().find('.powermail_form')
        .children().find(':invalid').closest('.float-target-parent')
        .addClass('error');
    });

    $(".powermail_form").on("change", function(){
        $(this).children().find(':valid').closest('.float-target-parent').removeClass('error');
        $(this).children().find(':invalid').closest('.float-target-parent').addClass('error');
    });

};